module.exports = __webpack_public_path__ + "img/CW.c9a69d74.svg";